//#region Libraries
import { Row } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled(Row).attrs({
	width: "100%",
	justifyContent: "center"
})``;